/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {

    export class TreeItemService extends services.DataService<Wars.Domain.Model.TreeItem> {

        private utilityService: services.UtilityService;

        constructor(
            injectedBreeze: typeof breeze,
            $q: angular.IQService,
            utilityService: services.UtilityService) {
            super(injectedBreeze, $q);
            this.utilityService = utilityService;
        }

        public getTreeItem(id: string): angular.IPromise<Wars.Domain.Model.TreeItem> {
            var query = this.breezeModule.EntityQuery
                .from("TreeItems")
                .where("id", "==", id)
                .expand("schemaProperty, calculation.inputSchema.properties, condition, constantValue, formStep, claim");

            return this.fetch(query);
        }

        public createTreeItem(isSystemLevel: boolean): Wars.Domain.Model.TreeItem {
            return this.createNewEntity<Wars.Domain.Model.TreeItem>("TreeItem", {isSystemLevel: isSystemLevel});
        }
    }
}

warsApp.registerService('TreeItemService', ['breeze', '$q', 'utilityService']);